<aside class="sidebar">
  <div>
    <header class="sidebar-header justify-content-center text-center mb-5">
      <div class="d-flex flex-column align-items-center gap-1">
        <svg-icon class="logo" [src]="'assets/image/logo_small.svg'"></svg-icon>
        <app-powered-by [variant]="'white'"></app-powered-by>
      </div>
    </header>

    <nav class="pt-md-5">
      @for (sideBarItem of menuItems$ | async; track sideBarItem) {
        <button type="button"
          class="btn btn-side-navigation pe-0"
          [routerLink]="sideBarItem.link"
          [routerLinkActiveOptions]="{ exact: false }"
          [routerLinkActive]="['active']">
          <div class="d-flex align-items-center gap-2">
            @if (sideBarItem?.icon) {
              <i-tabler [name]="sideBarItem.icon" class="icon"></i-tabler>
            }
            <span class="label d-inline d-lg-inline">
              {{ sideBarItem.title | prefix: 'COMPONENT.SIDE_MENU' | translate }}
            </span>
          </div>
        </button>
      }
    </nav>
  </div>
  @if ((language$ | async); as selectedLanguage) {
    <div class="dropdown" dropdown container="body" placement="top left" [autoClose]="true">
      <button type="button" class="btn language-selector" dropdownToggle>
        <div class="d-flex align-items-center gap-3">
          <i-tabler class="icon" name="world-pin"></i-tabler>
          {{ selectedLanguage | uppercase }}
        </div>
        <i-tabler class="icon" name="chevron-down"></i-tabler>
      </button>
      <div class="dropdown-menu" *dropdownMenu >
        @for (language of LanguageVersion | enumToArray; track language) {
          <button type="button" class="dropdown-item" (click)="changeLanguage(language)" [ngClass]="{'current-language': selectedLanguage === language }">
            {{ language | uppercase }}
          </button>
        }
      </div>
    </div>
  }
</aside>
